export default __webpack_public_path__ + "static/media/spoolSheets4.b8c619db.jpg";